import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Divider, Steps, Timeline } from 'antd';
import classNames from 'classnames';
import { CheckCircle } from '~components/svgs';
import { CloseCircleOutlined } from '@ant-design/icons';

const uesStyles = makeStyles(
  theme => ({
    layout: {
      display: 'flex',
      flexDirection: 'column',
      width: '360px',
      backgroundColor: 'white',
      borderWidth: '4px 1px 1px 1px',
      borderColor: 'rgba(217, 217, 217, 1)',
      borderStyle: 'solid',
      borderRadius: '2px',
    },
    border_y: {
      borderTopColor: 'rgba(252, 206, 1, 1)',
    },
    border_g: {
      borderTopColor: 'rgba(90, 191, 178, 1)',
    },
    border_p: {
      borderTopColor: 'rgba(179, 127, 235, 1)',
    },
    pd24: {
      padding: '24px',
    },
    title: {
      fontSize: '24px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '32px',
    },
    description: {
      fontSize: '12px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.65)',
      lineHeight: '22px',
      minHeight: '66px',
      marginTop: '8px',
      marginBottom: '24px',
      '& .ant-timeline-item': {
        minHeight: '60px',
      },
      '& .ant-timeline-item-content ': {
        ...theme.typography.body2,
        color: theme.colors.bodyColor,
        marginLeft: '30px',
      },
    },
    subTitle: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.25)',
      lineHeight: '22px',
    },
    bg_y: {
      backgroundColor: 'rgba(252, 206, 1, 0.07)',
    },
    bg_g: {
      backgroundColor: 'rgba(228, 242, 238, 0.5)',
    },
    bg_p: {
      backgroundColor: 'rgba(249, 240, 255, 0.5)',
    },

    description_title: {
      fontSize: '12px',
      marginTop: '16px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    description_line: {
      display: 'flex',
      fontSize: '12px',
      fontWeight: 400,
      marginTop: '8px',
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '20px',
    },
  }),
  { name: 'Listing-Box' },
);

const { Step } = Steps;

function index({
  title,
  color,
  description,
  sign_up_button_text,
  student_experience,
  landlord_experience,
  onClick,
}) {
  const classes = uesStyles();
  const getCheckIcon = icon_status =>
    icon_status === 'enabled' ? (
      <CheckCircle
        style={{
          width: '14px',
          flexShrink: 0,
          height: '14px',
          margin: '3px 6px 0 0',
          color: '#38b2a6',
        }}
      />
    ) : (
      <CloseCircleOutlined
        style={{
          width: '14px',
          flexShrink: 0,
          height: '14px',
          margin: '3px 6px 0 0',
          color: 'rgba(191, 191, 191, 1);',
        }}
      />
    );
  return (
    <div className={classNames(classes.layout, classes[`border_${color}`])}>
      <div className={classes.pd24}>
        <div className={classes.title}>{title}</div>
        <div className={classes.description}>{description}</div>
        <Button
          type="primary"
          size="large"
          block
          onClick={() => {
            onClick(title);
          }}
        >
          {sign_up_button_text}
        </Button>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className={classes.pd24} style={{ minHeight: '342px' }}>
        <div className={classes.subTitle}>Student Experience</div>
        <div className={classes.description} style={{ marginTop: '32px' }}>
          <Timeline>
            {student_experience.map((item, index) => (
              <Timeline.Item
                key={index}
                dot={
                  <div
                    style={{
                      backgroundColor:
                        item.icon.status === 'disabled' ? '#E5E5E5' : 'rgba(252, 206, 1, 0.2)',
                      borderRadius: '32px',
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon.icon}
                  </div>
                }
              >
                {item.action}
              </Timeline.Item>
            ))}
          </Timeline>
        </div>
      </div>
      <div
        className={classNames(classes.pd24, classes[`bg_${color}`])}
        style={{ flex: '1', paddingBottom: '40px' }}
      >
        <div className={classes.subTitle}>Landlord Experience</div>
        {landlord_experience.map((item, index) => (
          <div key={index}>
            <div className={classes.description_title}>{item.title}</div>
            {item.content.map((ct, idx) => (
              <div key={idx} className={classes.description_line}>
                {getCheckIcon(ct.icon_status)}
                <div>{ct.description}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default index;
